<template>
  <el-dialog :visible.sync="dialogVisible" title="Download Privacy Contact List">
    <p>From here you can download privacy data defined by your parameters to a CSV file.</p>
    <el-form label-width="120px" ref="privacyForm" :model="form" :rules="rules">
      <el-form-item label="File name" prop="fileName">
        <el-input v-model="form.fileName" />
      </el-form-item>
      <el-form-item label="Dates" prop="rangeDate">
        <el-date-picker
          type="daterange"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          v-model="form.rangeDate"
        />
      </el-form-item>
      <el-form-item label="Privacy Types" prop="privacy">
         <el-transfer
          v-model="currentPrivacyTypes"
          :titles="['Available', 'Enabled']"
          :data="privacyData"
        ></el-transfer>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel" :disabled="isLoading">Cancel</el-button>
      <el-button type="primary" @click="handleFormSave" :disabled="isLoading
        || !selectedPrivacyTypes.length">
        <i class="fa fa-spinner fa-spin" v-show="isLoading"></i>
        Download
      </el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'PrivacyReportDialog',
  components: {},
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    privacy: {
      required: true,
    },
  },
  data: () => ({
    form: {
      fileName: '',
      rangeDate: [],
    },
    rules: {
      fileName: [
        { required: true, trigger: 'blur', message: 'Please enter a filename for this selection.' },
      ],
      rangeDate: [{ required: true, trigger: 'blur', message: 'Please enter a date range.' }],
    },
    selectedPrivacyTypes: [],
    isLoading: false,
  }),
  computed: {
    dialogVisible: {
      get() {
        return this.isVisible;
      },
      set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      },
    },
    currentPrivacyTypes: {
      get() {
        return this.selectedPrivacyTypes;
      },
      set(selectedPrivacyType) {
        this.selectedPrivacyTypes = selectedPrivacyType;
      },
    },
    privacyData() {
      return this.privacy.map(privacyTypes => ({
        key: privacyTypes.type,
        label: privacyTypes.type,
        disabled: privacyTypes.count.yes <= 0,
      }));
    },
  },
  methods: {
    handleFormSave() {
      this.$refs.privacyForm.validate(valid => {
        if (valid) return this.downloadReport();
        return false;
      });
    },

    async downloadReport() {
      const payload = {
        file_name: this.form.fileName.replace(/ /g, '_').toLowerCase(),
        date_from: this.form.rangeDate[0],
        date_to: this.form.rangeDate[1],
        privacy_types: this.selectedPrivacyTypes,
      };
      this.isLoading = true;
      return this.$store
        .dispatch('privacy/downloadOptinsReport', payload)
        .then(() => {
          this.$emit('onVisibleChanged', false);
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    handleCancel() {
      this.$emit('onVisibleChanged', false);
    },
  },
  mounted() {
    this.form.fileName = 'optin-contact-list-report';
  },
};
</script>



// WEBPACK FOOTER //
// PrivacyReportDialog.vue?0c84e12f